export enum ApplicationName {
  ALLIANCE = 'alliance',
  FISCALITE = 'fiscalite',
  INSITO = 'insito',
  INSITO_CH = 'insito_ch',
  INSITO_CORPO = 'insito_corpo',
  INVISEO = 'inviseo',
  PORTAL = 'portal',
  DOTATIONS = 'dotations',
  REPOSITORY = 'repository',
  PUBLICATION = 'publication',
  FUNDING_TENDER = 'funding_tender',
  BANK_PROPOSAL = 'bank_proposal',
  DASHBOARD = 'dashboard',
  ASSISTANCE = 'assistance',
  OBSERVATORY = 'observatory'
}
